import * as React from "react";
// import _ from "lodash";
import { Fragment } from "react";
import BaseListComponent, {
  IFilterData,
  BaseListComponentState,
} from "../../../components/BaseListComponent";
// import { printPDF } from "../../../services/utility/textFormatService";
import {
  createFilterData,
  mapEntityList,
} from "./../../../services/utility/autoMapperService";

import mandateService from "../../../services/mandate/mandateService";
import ItemsTable, {
  filterFieldData,
} from "../../../components/tableComponents/itemsTable";
import TableFilterPane from "./../../../components/tableComponents/tableFilterPane";
import MandateUploadRequestDetail from "./mandateUploadRequestDetail";
import {
  getCurrentUserSession,
  getCurrentUsersRoles,
} from "../../../services/auth/authService";
import { printPDF } from "../../../services/utility/textFormatService";
import { decodeToken } from "react-jwt";

export interface IMandateUploadRequestsProps {}

export interface IMandateUploadRequestsState extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
}

class MandateUploadRequestList extends BaseListComponent<IMandateUploadRequestsState> {}

class MandateUploadRequests extends React.Component<
  IMandateUploadRequestsProps,
  IMandateUploadRequestsState
> {
  constructor(props: IMandateUploadRequestsProps) {
    super(props);
    this.state = {
      data: createFilterData(["requestInitiator"]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [
        { name: "requestInitiator", fieldType: "text", value: "" },
      ],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
    };
  }

  handleOnExport = async (type: string) => {
    try {
      const decodedToken = decodeToken(getCurrentUserSession().token || "");
      switch (type) {
        case "XLSX":
        case "CSV":
          return await mandateService.downloadBulkMandateRequestsReport(
            decodedToken?.["InstitutionId"],
            type
          );
        case "PDF":
          const response =
            await mandateService.downloadBulkMandateRequestsReport(
              decodedToken?.["InstitutionId"],
              type
            );
          printPDF(response?.data);
          break;
        default:
          break;
      }
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
      }
    }
  };

  handlePageChange = async (currentPage: number, pageSize:number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    this.setState({ fetching: true });
    data = typeof data === "undefined" ? this.state.data : data;
    try {
      const requests = await mandateService.filterMandateUploadRequests(
        data,
        pageSize,
        currentPage
      );
      this.setState({
        tableItems: mapEntityList({
          entityList: requests.data.item2,
          properties: [
            { oldName: "institutionName", newName: "institutionName" },
            { oldName: "requestInitiator", newName: "initiator" },
            { oldName: "requestId", newName: "requestId" },
            { oldName: "noOfMandates", newName: "noOfMandates" },
            { oldName: "dateCreated", newName: "dateCreated" },
            {
              isTag: true,
              oldName: "status",
              newName: "status",
              success: "Approved",
              danger: "Cancelled",
              default: "default",
              primary: "primary",
              secondary: "secondary",
              warning: "Pending",
              light: "",
              dark: "dark",
            },
          ],
        }),
        currentPage,
        pageSize,
        totalSize: requests.data.item1,
        fetching: false,
      });
    } catch (ex) {
      this.setState({ fetching: false });
      // console.log("caught exception", ex);
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
        // this.setState({ errors, fetching: false });
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        // this.setState({ errors, fetching: false });
      }
    } finally {
      this.setState({ fetching: false });
    }
  };

  fetchItemById = async (item: any) => {
    this.setState({ fetchingDetail: true });
    const request = await mandateService.retrieveBulkMandateUploadRequestById(
      item.id
    );
    this.setState({ item: request.data, fetchingDetail: false });
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
  }

  render() {
    const {
      // data,
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>Bulk Mandate Upload Requests</b>
              </h3>
            </div>
            <MandateUploadRequestList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              initialValues={{
                data: createFilterData(["requestInitiator"]) as IFilterData,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: this.state.filterValueInput,
                item: {},
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                showDetailsModal,
              }) => (
                <Fragment>
                  <MandateUploadRequestDetail
                    showDetailsModal={showDetailsModal}
                    toggleDetailsModal={onToggleDetailsModal}
                    currentUserRoles={getCurrentUsersRoles()}
                    item={item}
                    reloadItem={(item: any) => {
                      this.fetchItemById(item);
                    }}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="Bulk Upload Mandate Requests"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                              //   amountColumn={["loanAmount"]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></MandateUploadRequestList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default MandateUploadRequests;
